import styled from 'styled-components';
import media from '../../../../constants/media';

export const Wrapper = styled.div`
	margin-bottom: 5rem;
`;

export const TrackingNumberWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;

	${media.mobileOnly`
		flex-wrap: wrap;
	`};
`;

export const ButtonWrapper = styled.div`
	margin-left: 1.5rem;

	${media.mobileOnly`
		display: flex;
		justify-content: center;
		width: 100%;
		margin-left: 0;
		margin-top: 1rem;
	`};
`;

export const AcceptedTrackingNumbers = styled.div`
	display: flex;
	margin-top: 2rem;
	flex-wrap: wrap;
`;

export const AcceptedTrackingNumber = styled.div`
	border-radius: 3rem;
	padding: 1rem;
	padding-left: 2rem;
	margin-right: 2rem;
	background: ${({ theme }) => theme.colors.grayLight};
	display: flex;
	justify-content: center;
	position: relative;
	padding-right: 5rem;
	margin-top: 1rem;
	p {
		margin-bottom: 0;
	}
	svg {
		margin-left: 1rem;
		width: 3rem;
		height: 3rem;
		position: absolute;
		right: 1rem;
		top: 1rem;
		cursor: pointer;
	}
`;

export const StyledErrorMessage = styled.div`
	margin: 0.5rem;
	font-size: 1.4rem;
	color: ${({ theme }) => theme.colors.primaryDark};
`;
